export interface DocumentPreviewEditSearchCriteria {
    cntrNoList: string[],
    inputDraftDocNo: string,
    chargeType: string,
    subChargeType: string,
    adreState: string,

    draftState: string,
    draftDocNo: string,
    consortiumCode: string,
    vesselCode: string,
    voyageCode: string,
    etd: Date | null,
    billToCompany: string,
    docHdrId: number,
    isFromBut: boolean,
    isApprove: boolean,


    [key: string]: string[] | string | Date | boolean | number | number[] | null | undefined
}

export const EMPTY_DOCUMENT_PREVIEW_EDIT_SEARCH_CRITERIA: DocumentPreviewEditSearchCriteria = {
    cntrNoList: [],
    draftDocNo: "",
    chargeType: "",
    subChargeType: "",
    adreState: "",
    consortiumCode: "",
    vesselCode: "",
    voyageCode: "",
    etd: null,
    billToCompany: "",
    docHdrId: 0,
    inputDraftDocNo: "",
    draftState: "",
    isFromBut: false,
    isApprove: false
}